<app-form-field [formGroup]="form" *ngIf="!form.value.video && !uploading">
  <label class="!text-[14px]" app-label translate>trilhas.link</label>
  <input app-input formControlName="link" [placeholder]="'trilhas.link' | translate" />
</app-form-field>

<app-form-field *ngIf="!form.value.link; else preview" [required]="true">
  <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.anexo-principal</label>
  <app-upload-file
    *ngIf="!uploaded && !form.value.video; else preview"
    class="w-full"
    [config]="config"
    [invalid]="submittedForm && form.controls.video.invalid"
    (processing)="onProcessingVideo()"
    (statusChange)="onUpload($event)"
  ></app-upload-file>
  <span app-error *ngIf="submittedForm && form.controls.video.invalid" translate>geral.erros.required</span>
</app-form-field>

<ng-template #preview>
  <div class="mr-5 flex justify-end" *ngIf="!!form.value.video && !rendering$.value">
    <button type="button" app-flat-button (click)="onDelete()">
      <svg-icon
        app-tooltip
        [tooltip]="'geral.excluir' | translate"
        class="h-6 w-6 text-red-500"
        src="assets/icons/icon-trash.svg"
      ></svg-icon>
    </button>
  </div>

  <div *ngIf="preview_url$ | async as preview_url" class="flex w-full justify-center">
    <iframe
      *ngIf="preview_url"
      class="left-0 top-0 h-[40vh] w-[36vw]"
      [src]="preview_url | safe : 'resourceUrl'"
      frameborder="0"
      allow="autoplay; fullscreen"
      title="video_preview"
    ></iframe>
  </div>
  <app-jumbotron *ngIf="rendering$.value" [showIcon]="false" translate class="mb-5">
    <div class="flex w-full flex-col items-center justify-center gap-5 p-8" translate>
      <svg-icon
        class="w-14 animate-pulse text-base-trilhas-tipo-video"
        src="assets/icons/icon-video-aula.svg"
      ></svg-icon>
      <p class="text-[14px] font-normal text-theme-950" translate>geral.video-renderizando</p>
    </div>
  </app-jumbotron>
</ng-template>
